import { render, staticRenderFns } from "./BidWin.vue?vue&type=template&id=ae5cc60c&scoped=true&"
import script from "./BidWin.vue?vue&type=script&lang=js&"
export * from "./BidWin.vue?vue&type=script&lang=js&"
import style0 from "./BidWin.vue?vue&type=style&index=0&id=ae5cc60c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5cc60c",
  null
  
)

export default component.exports